import {ROUTES_PATHS} from "../const/routes";
import {map, take} from "rxjs/operators";
import {Observable} from "rxjs";
import {SharedToolsService} from "../services/shared-tools.service";
import {CanActivate, Router, UrlTree} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class MyAccountSpaceGuard implements CanActivate {

	constructor(
		private router: Router,
		private sharedToolsService: SharedToolsService
	) {}

	canActivate(): Observable<boolean | UrlTree> {
		return this.sharedToolsService
			.denyAccessToMyAccountSpace()
			.pipe(
				take(1),
				map((denyAccess) => {
					if (denyAccess) {
						return this.router.parseUrl(
							ROUTES_PATHS.WELCOME
						);
					}

					return true;
				})
			);
	}
}
